export const genderList = [
	{
		key: "woman",
		value: 0,
		meta: {
			url: "woman",
			value: 1,
		},
	},
	{
		key: "man",
		value: 1,
		meta: {
			url: "man",
			value: 2,
		},
	},
	{
		key: "couple",
		value: 2,
		meta: {
			url: "couple",
			value: 4,
		},
	},
	{
		key: "transsexual",
		value: 3,
		meta: {
			url: "transsexual",
			value: 8,
		},
	},
];

export const MONTHS = [
	{ text: "january", number: "01" },
	{ text: "february", number: "02" },
	{ text: "march", number: "03" },
	{ text: "april", number: "04" },
	{ text: "may", number: "05" },
	{ text: "june", number: "06" },
	{ text: "july", number: "07" },
	{ text: "august", number: "08" },
	{ text: "september", number: "09" },
	{ text: "october", number: "10" },
	{ text: "november", number: "11" },
	{ text: "december", number: "12" },
];
export const WEEK_DAYS = [
	"monday",
	"tuesday",
	"wednesday",
	"thursday",
	"friday",
	"saturday",
	"sunday",
];
export const POSITION_DEFAULT = -1;
export const POSITION_LAST = 0;
export const CURRENT_DATE = new Date();
export const TOTAL = "total";
export const LATEST = "latest";
export const CURRENT_YEAR = CURRENT_DATE.getFullYear();
